import React from 'react';

const FilterState = (props) => {

  return (
    <div className='filter-tags filter-tags--state'>
      <select onChange={props.handleStateFilter} defaultValue={props.selected}>
        <option value='all'>{Drupal.t('All')}</option>
        {Object.entries(props.states).map(([stateId, state], i) => (
          <option key={i} value={stateId}>{state}</option>
        ))}
      </select>
    </div>
  );
};

export default FilterState;